import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #ccc;
  background: var(--primary-contrast-text, #fff);
  box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.16);
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
`;

export const FirstText = styled.span`
  color: var(--text-secondary-54-p, rgba(0, 0, 0, 0.54));
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0.15px;
`;

export const SecondText = styled.span`
  color: rgba(0, 0, 0, 0.54);
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
  letter-spacing: 0.15px;
  margin-left: 5px;
`;
